import styled from "styled-components";

export const HomeStyled = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100dvh;
  /* max-width: 1920px; */
  margin: 0 auto;

  background: ${(props) => (props.darkmode ? "#292929" : null)};

  background: ${(props) => (props.darkmode ? ` var(--background-dark)` : null)};

  .IconAlerte {
    display: flex;
    justify-content: end;
    position: absolute;
    top: 60px;
    right: 5%;
    z-index: 5;
    button {
      font-size: 40px;
      cursor: pointer;
      padding: 0;
      background-color: transparent;
      border: none;
      z-index: 3;
      .iconStyledAlert {
        color: rgba(118, 118, 118, 1);
        transition: 0.5s;
      }
      .iconStyledAlert:hover {
        color: rgb(34, 34, 34);
      }
      .iconStyledAlertPorcesso {
        color: rgb(224, 169, 3);
        filter: drop-shadow(0px 0px 5px rgba(251, 255, 4, 0.45));

        animation: alertAnim 2s ease infinite;
      }
      .iconStyledAlertEmegencia {
        color: rgb(224, 3, 3);
        filter: drop-shadow(0px 0px 5px rgba(252, 0, 0, 0.45));
        animation: alertAnim 1s ease infinite;
      }
    }
  }

  .darkmode {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 15px;
    font-size: 18px;
    border-radius: 80px;
    background-color: ${(props) =>
      props.darkmode ? "#BABABA" : "var(--branco)"};
    border: 2px solid var(--cor-primaria);
    gap: 20px;
    position: relative;
    position: absolute;
    top: 60px;
    left: 5%;
    width: 90px;
    height: 50px;
    cursor: pointer;
    z-index: 5;
    span {
      position: absolute;
      background-color: var(--cor-primaria);
      width: 40px;
      height: 40px;
      border-radius: 50%;
      left: ${(props) => (props.darkmode ? "41px" : "5px")};
      transition: 0.8s;
    }
    .icone01 {
      color: ${(props) => (props.darkmode ? "black" : "white")};
      transition: 1.3s;
      z-index: 5;
    }
    .icone02 {
      color: ${(props) => (props.darkmode ? "white" : "black")};
      transition: 1.3s;
      z-index: 5;
    }
  }

  .conteinerUnidade {
    max-width: 95%;
    max-height: 94vh;
    display: flex;
    flex-direction: column;
    z-index: 1;
    /* border: 3px solid var(--cor-primaria);
    box-shadow: 2px 2px 10px var(--shadow);
    border-radius: 10px;
    padding-top: 15px; */
    gap: 30px;
    overflow: hidden;
    padding: 15px;
    padding-bottom: 25px;

    .nomePoco {
      font-size: 22px;
      text-align: start;
      margin-bottom: 10px;
      color: var(--cor-contraste);

      color: ${(props) =>
        props.darkmode ? "var(--branco)" : "var(--cor-contraste)"};
    }

    h2,
    h3 {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 1.5rem;
    }

    .conteudoRolavel {
      overflow-y: auto;
      flex-grow: 1;
      padding-top: 15px;
    }

    .botoes {
      display: flex;
      gap: 20px;
      padding: 10px;
      flex-wrap: wrap;
      justify-content: center;

      button {
        display: flex;
        position: relative;
        justify-content: end;
        flex-direction: column;
        align-items: center;
        /* background: var(--degrade); */
        background-color: rgba(116, 116, 116, 0.42);
        font-size: 1.4rem;
        max-width: 100%;
        max-height: 100%;
        border-radius: 10px;
        gap: 12px;
        color: var(--branco);
        cursor: pointer;
        border: 2px solid var(--cor-contraste);
        border: 2px solid rgb(29, 59, 85);
        padding: 10px 10px;
        transition: 0.3s;
      }
      .PocoConteiner {
        display: flex;
        align-items: center;
        justify-content: center;
        .grandehome {
          width: 190px;
          height: 260px;
          margin: 28px 0px;
        }
      }
      img {
        width: 100px;
        max-width: 100%;
      }
      button:hover {
        background-color: rgba(116, 116, 116, 0.62);
        box-shadow: 2px 2px 10px var(--shadow);
      }
      .statusOnUnidade {
        position: absolute;
        background-color: var(--offline);
        width: 22px;
        height: 22px;
        top: -10px;
        right: -10px;
        border-radius: 50%;
        border: 2px solid var(--branco);
      }
      .statusOn {
        background-color: var(--online);
        border: 2px solid var(--branco);
      }

      .IconAlerte {
        display: flex;
        justify-content: start;
        position: absolute;
        left: 0px;
        top: -22px;
        font-size: 30px;

        .iconStyledAlert {
          color: rgb(48, 230, 3);
          /* color: rgba(0, 0, 0, 1); */
          transition: 0.5s;
        }
        .iconStyledAlert:hover {
          color: rgb(34, 34, 34);
        }
        .iconStyledAlertPorcesso {
          color: rgb(229, 255, 0);
          filter: drop-shadow(0px 0px 5px rgba(251, 255, 0, 0.8));

          animation: alertAnim 2s ease infinite;
        }
        .iconStyledAlertEmegencia {
          color: rgb(255, 0, 0);
          filter: drop-shadow(0px 0px 5px rgba(255, 0, 0, 0.74));
          animation: alertAnim 1s ease infinite;
        }
      }
      .BombaInfo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        gap: 2px;
        .conteinerBomba {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 5px;
        }
        .TituloBomba {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          color: ${(props) =>
            props.darkmode ? "var(--branco)" : "var(--cor-contraste)"};
          .iconHomeBomba {
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--cor-contraste);
            font-size: 26px;
          }
          .GiroBomba {
            animation: ${"giroBomba"} 1.5s linear infinite;
            color: rgb(10, 182, 59);
          }
          h3 {
            font-size: 18px;
          }
        }
        .imgBomba {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100px;
          /* background-color: aqua; */
          position: relative;

          img {
            width: 49px;
            height: 95px;

            filter: drop-shadow(0.5px 0.5px 1px white);
            ${(props) =>
              props.darkmode &&
              "filter: brightness(0) invert(1) drop-shadow(0.5px 0.5px 1px black);"};
          }

          .iconHomeBomba {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--cor-contraste);
            font-size: 42px;
            bottom: 20.5px;
            color: rgb(43, 53, 46);
            .iconN {
              stroke: white; /* cor da borda */
              stroke-width: 6; /* espessura */
            }
          }
          .GiroBomba {
            animation: ${"giroBomba"} 1s linear infinite;
            color: rgb(14, 145, 51);
          }
          .falhaBomba {
            color: rgb(102, 0, 0);
          }
        }
        .divControlerConteiner {
          display: flex;

          .divControler {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 5px;
            gap: 5px;
            font-size: 12px;
            color: var(--cor-contraste);
            .falha {
              color: var(--cor-erro);
              background-color: var(--cor-erro);
              font-weight: 600;
            }
            .desligada {
              color: white;
              background-color: rgba(96, 96, 96, 0.85);
              font-weight: 600;
              font-size: 14px;
              width: 85px;
              padding: 5px;
              border-radius: 7px;
            }
            .ligada {
              color: white;
              background-color: rgb(7, 138, 44);
              font-weight: 600;
              font-size: 14px;
              width: 70px;
              padding: 5px;
              border-radius: 10px;
            }
            .falha {
              color: white;
              background-color: rgb(201, 8, 8);
              font-weight: 600;
              font-size: 14px;
              width: 70px;
              padding: 5px;
              border-radius: 10px;
            }
          }
        }
      }

      .statusPainel {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 15px;
        margin: 0 5px;
        padding: 0 5px;
        .divControler {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
          p {
            font-size: 0.75rem;
            width: 50px;
            color: var(--cor-contraste);
            color: ${(props) =>
              props.darkmode ? "var(--branco)" : "var(--cor-contraste)"};
          }
          font-weight: 600;
        }
      }
    }
  }

  .IconBaixaApp {
    display: flex;
    justify-content: end;
    position: absolute;
    bottom: 50px;
    right: 15px;
    button {
      color: var(--branco);
      font-size: 15px;
      padding: 5px;
      cursor: pointer;
      background: var(--degrade);
      border: 2px solid var(--branco);
      border-radius: 5px;
      z-index: 3;
      .Icon {
        font-size: 20px;
      }
    }
    @media screen and (min-width: 1000px) {
      display: none;
    }

    button:hover {
      background: var(--cor-secundaria);
      box-shadow: 2px 2px 10px var(--shadow);
      color: var(--branco);
      border: none;
    }
  }

  /* Estilos para dispositivos móveis em modo retrato */
  @media only screen and (max-width: 800px) and (orientation: portrait) {
    .conteinerUnidade {
      margin: auto;
    }
  }

  //Estilos para dispositivos móveis em modo paisagem
  @media only screen and (max-width: 940px) and (orientation: landscape) {
    height: 120vh;
    padding-top: 5.5em;
    .conteinerUnidade {
      gap: 5px;
      width: 85%;
      margin: auto;
    }
  }
`;

export const CxControle = styled.div`
  width: 23px;
  max-width: 100%;
  height: 23px;
  border-radius: 5px;
  border: 1px solid rgb(25, 11, 125);
  background: ${(props) => props.activo};
`;

export const ModalStyledAllAvisoEmergencia = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;

  .conteiner {
    width: 80%;
    height: 85%;
    border-radius: 15px;
    position: relative;
    background: var(--cinza);
    border: 5px solid var(--cor-primaria);
    padding: 15px;

    .Closemodal {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      right: -10px;
      top: -10px;
      font-size: 22px;
      cursor: pointer;
      background: var(--cinza);
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 2px solid var(--cor-primaria);
    }

    .SelectSections {
      display: flex;
      justify-content: center;
      width: 100%;
      gap: 15px;

      h2 {
        padding: 2px;
        color: rgba(107, 107, 107, 0.8);
        border-bottom: 3px solid rgba(107, 107, 107, 0.8);
      }
      .sectionAtive {
        color: rgb(0, 0, 0);
        border-bottom: 3px solid rgb(0, 0, 0);
      }
    }

    section {
      display: flex;
      width: 100%;
      height: 100%;
      max-height: 90%;

      .alertsOk {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        h2 {
          text-align: center;
        }
      }
    }

    .ulHistorico {
      display: flex;
      flex-direction: column;
      gap: 25px;
      width: 100%;
      overflow: auto;
      padding: 15px;
      padding-top: 25px;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 2px;
        border-bottom: 4px solid rgba(6, 129, 25, 1);
        padding-right: 10px;
        /* flex-wrap: wrap; */

        .iconStyled {
          display: flex;
          margin-bottom: 5px;
          font-size: 40px;
          height: 100%;
          /* align-items: end; */
        }
        .Status {
          display: flex;
          flex-direction: column;
          gap: 5px;
          align-items: center;
          justify-content: space-around;
          height: 100%;
          .top {
            font-weight: 600;
            font-size: 17px;
          }
          p {
            text-align: center;
            width: 350px;
            max-width: 100%;
            word-wrap: break-word; /* Quebra a palavra se for muito longa */
            overflow-wrap: break-word; /* Garante a quebra */
            white-space: normal; /* Permite múltiplas linhas */
          }
          .Statusalert {
            text-align: center;
            width: 150px;
            max-width: 100%;
            word-wrap: break-word; /* Quebra a palavra se for muito longa */
            overflow-wrap: break-word; /* Garante a quebra */
            white-space: normal; /* Permite múltiplas linhas */
          }
          button {
            padding: 5px;
            width: 100px;
            cursor: pointer;
            border: 2px solid;
            font-weight: 600;
            border-radius: 5px;
          }
          .buttonPendente {
            border: 2px solid rgb(201, 19, 6);
            color: rgb(201, 19, 6);
            transition: 0.5s;
          }
          .buttonPendente:hover {
            border: 2px solid rgb(217, 207, 12);
            color: white;
            background-color: rgb(217, 207, 12);
          }
          .buttonProgresso {
            border: 2px solid rgb(170, 145, 7);
            color: rgb(170, 145, 7);
            transition: 0.5s;
          }
          .buttonProgresso:hover {
            border: 2px solid rgba(6, 129, 25, 1);
            color: white;
            background-color: rgba(6, 129, 25, 1);
          }
        }
      }
      .pedente {
        border-bottom: 4px solid rgb(201, 19, 6);
      }
      .manuteçao {
        border-bottom: 4px solid rgb(201, 191, 6);
      }
    }
  }

  /* Estilos para dispositivos móveis em modo retrato */

  @media screen and (max-width: 1400px) {
    .conteiner {
      width: 95%;
      .ulHistorico {
        li {
          gap: 8px;
          flex-direction: column;
          align-items: flex-start;

          .Status {
            display: flex;
            flex-direction: row;
            gap: 15px;
            .top {
              display: flex;
              align-items: center;
              height: 100%;
              /* justify-content: center; */
              max-width: 85px;
              min-width: 85px;

              /* background-color: red; */
            }
            p {
              text-align: start;
              width: 100%;
            }
          }
        }
      }
    }
  }
`;

export const ModalStyledBaixaApp = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;

  .conteiner {
    display: flex;
    flex-direction: column;
    width: 80%;
    height: 65%;
    border-radius: 15px;
    position: relative;
    background: var(--cinza);
    border: 5px solid var(--cor-primaria);
    justify-content: center;
    align-items: center;

    .titleModal {
      position: absolute;
      top: 0px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 10px;
      font-size: 10px;
      width: 100%;

      .Closemodal {
        right: 10px;
        top: 10px;
        font-size: 22px;
        cursor: pointer;
        /* font-size: 22px; */
      }
    }

    .BotoesApps {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      width: 100%;
      /* background-color: aqua; */
      button {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        border: none;
        border-radius: 10px;
        width: 70%;
        height: 60px;
        border: 2px solid var(--cor-primaria);
        .IconApps {
          font-size: 25px;
        }
        p {
          font-size: 25px;
        }
      }
    }
  }
`;
